import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/_services/app.service";

@Component({
  selector: "app-demande-sent",
  templateUrl: "./demande-sent.component.html",
  styleUrls: ["./demande-sent.component.scss"],
  standalone: false,
})
export class DemandeSentComponent implements OnInit {
  @Output() cancle: EventEmitter<any> = new EventEmitter<any>();

  constructor(private appService: AppService) {}

  ngOnInit() {}
  handleCancle() {
    this.appService.dispatchModal("FREE_DEMAND_CLIENT_MODAL", false);
    this.cancle.emit();
  }
}
